var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-not-found"},[_c('Error',{attrs:{"message":_vm.$t('Page Not Found')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }